import "./RegistrationLayout.scss";
import { useEffect, useState } from "react";
import Register from "../../components/Registration/Register";
import BpSiteIdVerification from "../../components/Registration/BpSiteVerification";
import { UserService } from "../../services/UserService";
import { RegistrationSuccess } from "../../components/Registration/RegistrationSuccess";
import { LOGIN_LITERALS } from "../../constants/literals";
import BrandingImage from "../../components/shared/SVG/BrandingImage";

export default function RegistrationLayout() {
  const [currentStep, setCurrentStep] = useState<number>(
    Number(UserService.currentStep) || 1
  );
  const [bpSiteId, setBpSiteId] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);
  const reset = () => {
    UserService.currentStep = "1";
    setCurrentStep(1);
  };
  useEffect(() => {
    setCurrentStep(Number(UserService.currentStep) || currentStep);
  }, []);
  return (
    <div className="registration-container d-flex h-100vh">
      <div className="left-container d-flex align-items-center justify-content-center p-2">
        <div>
          <BrandingImage color={"#ffffff"} className="branding-image" />
        </div>
      </div>
      <div className=" d-flex align-items-center flex-column justify-content-center right-container">
        <div className="d-flex align-items-center justify-content-center registration-wrapper w-100 flex-column position-relative">
          {currentStep === 1 && (
            <Register
              nextStep={nextStep}
              prevStep={prevStep}
              getBpSiteId={(siteId: string) => setBpSiteId(siteId)}
              getEmail={(email: string) => setEmail(email)}
            />
          )}
          {currentStep === 2 && (
            <BpSiteIdVerification
              nextStep={nextStep}
              prevStep={prevStep}
              bpSiteId={bpSiteId}
            />
          )}
          {currentStep === 3 && (
            <RegistrationSuccess reset={reset} bpSiteId={bpSiteId} />
          )}
          <div className="support">
            <div className="copy-rights-wrapper d-flex justify-content-between">
              <div className="copy-rights-content">
                {LOGIN_LITERALS.copyRights}
              </div>
              <div className="d-flex gap-4 privacy-policy-wrapper">
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_TERMS_URL);
                  }}
                >
                  Terms of Use
                </span>
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_PRIVACY_URL);
                  }}
                >
                  Privacy Policy
                </span>
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_SUPPORT_LINK);
                  }}
                >
                  Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
